<script>
    import Header from "../components/Header.svelte";
    import LearnMore from "../components/LearnMore.svelte";
    import MessageBox from "../components/MessageBox.svelte";
    import WhiteButton from "../components/WhiteButton.svelte";
    import CenterThis from "../components/CenterThis.svelte";
    import DottedContainer from "../components/DottedContainer.svelte";
    import {onMount, tick} from "svelte";
    import {writable} from "svelte/store"
    import BendService from "../services/BendService";
    import EncryptionService from "../services/EncryptionService";
    import InputBox from "../components/InputBox.svelte";
    import Spinner from "../components/Spinner.svelte";
    import {push} from 'svelte-spa-router';
    import CopyService from "../services/CopyService";

    export let params = {};

    let token;
    let secret;
    let messageStore = writable("");
    let tfaPhoneStore = writable("");
    let tfaCodeStore = writable("");

    let disableInitialButton = false;
    let disableRequestTfa = false;
    let disableSendTfa = false;

    let tfaSendError = false;

    const PHASES = {
        LOADING: 'LOADING',
        BURNED: 'BURNED',
        REQUEST: 'REQUEST',
        SEND_TFA: 'SEND_TFA',
        VERIFY_TFA: 'VERIFY_TFA',
        VIEW: 'VIEW',
    };

    let phase = PHASES.LOADING;

    onMount(function () {
        BendService.post('check-message', {token: params.token})
                .then(function () {
                    phase = PHASES.REQUEST
                })
                .catch(function (err) {
                    switch (err.status) {
                        case 401:
                            loadTfa(err);
                            break;
                        case 404:
                            loadBurnt(err);
                            break;
                        default:
                            loadBurnt(err);
                    }
                })
    });

    function copy() {
        CopyService.copy('message-box');
    }

    function loadTfa(err) {
        err.json().then((body) => {
            $tfaPhoneStore = body.maskedNumber;
            phase = PHASES.SEND_TFA;
        });
    }

    function loadBurnt() {
        phase = PHASES.BURNED;
        push(`/burned`);
    }

    function handleMessageResponse(response) {
        return EncryptionService
                .decrypt(EncryptionService.base64DecToArr(decodeURIComponent(params.secret)), response.message)
                .then(function (response) {
                    messageStore.set(response);
                    phase = PHASES.VIEW;
                });
    }

    function openInitialLink() {
        disableInitialButton = true;
        BendService.post('get-message', {token: params.token})
                .then(handleMessageResponse)
                .catch(loadTfa)
                .finally(() => {
                    disableInitialButton = false;
                })
    }

    function requestTfa() {
        $tfaCodeStore = '';
        disableRequestTfa = true;
        tfaSendError = false;
        tick().then(() => document.querySelector('input').focus());
        BendService.post('send-2f-code', {token: params.token})
                .then(function () {
                    phase = PHASES.VERIFY_TFA;
                })
                .finally(() => {
                    disableRequestTfa = false;
                })
    }

    function submitTfa() {
        disableSendTfa = true;
        BendService
                .post('get-message', {token: params.token, code: $tfaCodeStore})
                .then(handleMessageResponse)
                .catch(() => {
                    tfaSendError = true;
                })
                .finally(() =>{
                    disableSendTfa = false;
                })
    }

</script>

<style>
    section {
        padding: 0 20px 0 20px;
    }

    .column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .copy-container {
        opacity: 1;
    }

    .hidden {
        opacity: 0;
    }

    .message-container {
        display: flex;
        flex-direction: column;
        max-width: 100%;
        align-items: center;
    }

</style>

<section>

    <Header>You've received a self-destructing message</Header>
    <LearnMore>
        This burn link contains an encrypted message that can be viewed only once and then will be permanently
        destroyed.
        <br><br>
    </LearnMore>
    <CenterThis>
        {#if phase === PHASES.REQUEST}
            <DottedContainer>
                <CenterThis>
                    <div class="column">
                        <h2 style="text-align: center">READY TO VIEW THIS MESSAGE?</h2>
                        <br><br>
                        <WhiteButton disabled={disableInitialButton} click={openInitialLink}>Unlock Message</WhiteButton>
                    </div>
                </CenterThis>
            </DottedContainer>
        {/if}
        {#if phase === PHASES.SEND_TFA}
            <DottedContainer>
                <div class="column">
                    <h2>2-factor authentication</h2>
                    <LearnMore disableLink={true}>
                        This link requires additional verification via SMS.
                        A verification code will be sent to the mobile phone number below.
                    </LearnMore>
                    <InputBox store={tfaPhoneStore} readOnly={true}/>
                    <WhiteButton disabled={disableRequestTfa} click={requestTfa}>Send Code</WhiteButton>
                </div>
            </DottedContainer>
        {/if}

        {#if phase === PHASES.VERIFY_TFA}
            <DottedContainer>
                <div class="column">
                    <h2>2-factor authentication</h2>
                    <LearnMore disableLink={true}>
                        Verification code sent.<br> Please submit the code below before the session times out.
                        {#if tfaSendError}
                            <p style="    background: black;
    border-radius: 8px;
    padding: 4px;
    font-size: 16px;" >The code you submitted is invalid, please try again or<br/> <b><a class="link" style="font-size: 16px" on:click={requestTfa}>send a new verification code</a></b></p>
                        {/if}
                    </LearnMore>
                    <InputBox id="send-tfa-input" store={tfaCodeStore}/>
                    <WhiteButton disabled={disableSendTfa} click={submitTfa}>Verify</WhiteButton>
                </div>
            </DottedContainer>
        {/if}

        {#if phase === PHASES.VIEW}
            <div class="message-container">
                <MessageBox store={messageStore} readOnly={true}/>
                <div style="max-width: 250px">
                <WhiteButton floatText="Copied" click={copy}>Copy Message</WhiteButton>
                </div>
            </div>
        {/if}

        {#if phase === PHASES.LOADING}
            <DottedContainer ghosted={true}>
                <CenterThis>
                    <Spinner/>
                </CenterThis>
            </DottedContainer>
        {/if}

    </CenterThis>
</section>
